import { NavLink } from 'react-router-dom';

/**
 * Global navigation bar.
 * Persistent across all views. Uses NavLink for active-state styling.
 */
export default function Navigation() {
    return (
        <nav className="global-nav">
            <div className="global-nav__brand">
                <span className="global-nav__logo">CSP Visualizer</span>
                <span className="global-nav__badge">ALPHA</span>
            </div>
            <div className="global-nav__links">
                <NavLink
                    to="/"
                    end
                    className={({ isActive }) => `global-nav__link${isActive ? ' global-nav__link--active' : ''}`}
                >
                    Visualizer
                </NavLink>
                <NavLink
                    to="/test"
                    className={({ isActive }) => `global-nav__link${isActive ? ' global-nav__link--active' : ''}`}
                >
                    Test Yourself
                </NavLink>
            </div>
            <a
                href="https://www.linkedin.com/in/omer-farkash/"
                target="_blank"
                rel="noopener noreferrer"
                className="global-nav__feedback"
                title="Feedback welcome!"
            >
                <svg width="12" height="12" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
                Feedback
            </a>
        </nav>
    );
}
